if (!customElements.get('footer-menu-accordion')) {
  customElements.define('footer-menu-accordion', class extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.onLayoutChange = () => this.applyLayout();
      this.onToggle = event => {
        if (event.target.matches('.ks-footer-menu')) this.syncExpanded(event.target);
      };
      this.onEscape = event => {
        if (event.key !== 'Escape' || this.desktop.matches) return;
        const details = event.target.closest('.ks-footer-menu[open]');
        if (!details || !this.contains(details)) return;
        details.open = false;
        details.querySelector('summary').focus();
      };
      this.onBlockSelect = event => {
        const details = event.target.closest('.footer-block')?.querySelector('.ks-footer-menu');
        if (details && this.contains(details)) details.open = true;
      };
      this.addEventListener('toggle', this.onToggle, true);
      this.addEventListener('keyup', this.onEscape);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.desktop.addEventListener('change', this.onLayoutChange);
      this.applyLayout();
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.onToggle, true);
      this.removeEventListener('keyup', this.onEscape);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.desktop?.removeEventListener('change', this.onLayoutChange);
    }

    applyLayout() {
      this.querySelectorAll('.ks-footer-menu').forEach(details => {
        details.open = this.desktop.matches;
        this.syncExpanded(details);
      });
    }

    syncExpanded(details) {
      details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
    }
  });
}
